<template>
  <div id="account-nav">
    <b-nav pills>
      <b-nav-item
        v-for="menu in subMenuList"
        :key="menu.value"
        :active="menu.value === menuSelected"
        :class="{'tab-selector': true, active: menu.value === menuSelected}"
        exact-active-class="active"
        link-classes="tab-selector"
        @click="selectNav(menu.value)"
      >
        {{ menu.name }}
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>

export default {
    name: "AccountNav",
    props: {
        menuSelected: {
            type: String,
            default: "document"
        }
    },
    data() {
        return {
            subMenuList: [
                {
                    name: "ออกเอกสาร",
                    value: "document"
                },
                {
                    name: "ออกรายงาน",
                    value: "report"
                },
                {
                    name: "สถิติและข้อมูล",
                    value: "stat"
                }
            ]
        };
    },
    methods: {
        selectNav (value) {
            this.$emit("update:menuSelected", value)
        }
    }
};
</script>

<style scoped></style>
